import { render, staticRenderFns } from "./ProspectItem.vue?vue&type=template&id=8ff50abc&scoped=true&"
import script from "./ProspectItem.vue?vue&type=script&lang=js&"
export * from "./ProspectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff50abc",
  null
  
)

export default component.exports